import React from 'react';
import { Tooltip } from '@ss/mtd-react';
import { datejs } from '@block/utils';
import { doAction } from '../../utils';
import './index.scss';

interface Props {
  name: any;
  billCode?: string;
  badge?: string;
  id: string;
  onImgClick?: () => void;
  style?: any;
  rejectnum?: number;
  photoUrl: string;
  type?: number;
  onClick?: () => void;
}

interface State {
  rejectList: string;
}
class WorkCard extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      rejectList: '',
    };
  }

  handleChange = async () => {
    const { billCode } = this.props;
    const { rejectList } = this.state;
    // 未请求数据
    if (rejectList === ' ') {
      this.setState({ rejectList: '加载中...' });
      const resData: any = doAction(`/api/newcard/bpm/reject/reason/${billCode}`);
      if (resData.length) {
        const list = resData.map((item, index) => (
          <p key={index}>{`${datejs(item.actTime).format('YYYY-MM-DD HH:mm:ss')} ${item.comment}`}</p>
        ));
        this.setState({ rejectList: list });
      } else {
        this.setState({ rejectList: '数据获取失败' });
      }
    }
  };

  render() {
    const { badge, id, onImgClick, style, rejectnum, photoUrl, type, name, onClick } = this.props;
    const { rejectList } = this.state;
    return (
      <div className="work-card" style={style} onClick={onClick} key={id}>
        {photoUrl && [
          <div className="cardTitle" key={id}>
            <div className="title-name">{name || '姓名'}</div>
            <div className="title-mis">mis</div>
          </div>,
          <div key={type} className={`cardImg ${type === 1 && 'cardImgService'} `} id={id} onClick={onImgClick}>
            <img src={photoUrl} id="myworkcardImg" crossOrigin="anonymous" style={{ display: 'none' }} alt="" />
          </div>,
        ]}
        {badge && (
          <div className="cardBadge" id={id} onClick={onImgClick}>
            {rejectnum ? (
              <Tooltip message={rejectList} onVisibleChange={this.handleChange}>
                <div className="title-reject">{`驳回次数:${rejectnum || 0}`}</div>
              </Tooltip>
            ) : null}
            <img src={badge} alt="" />
          </div>
        )}
      </div>
    );
  }
}

export default WorkCard;
